module.exports = __webpack_public_path__ + "static/photo_mechanic-c3c0aca8e5a5880d7562824da661fa4a.png";